export const ADD_TABLE = 'ADD_TABLE'
export const ADD_TABLES = 'ADD_TABLES'
export const LOAD_TABLE = 'LOAD_TABLE'
export const LOAD_TABLES = 'LOAD_TABLES'
export const DELETE_TABLE_PERIMETER = 'DELETE_TABLE_PERIMETER'
export const SET_TABLE_ORDERS = 'SET_TABLE_ORDERS'
export const SET_ORDERS_TABLE_STATUS = 'SET_ORDERS_TABLE_STATUS'
export const SET_TABLES_STATUS = 'SET_TABLES_STATUS'